import React from 'react'


export default class extends React.Component {
  render() {
    return (
      <div>

        <div className="full terms-privacy">
          <div className="wrap wrap-thin">

            <h2>Privacy Policy</h2>
            <h3>What information does Polymedia collect?</h3>
            <p>Polymedia does not collect any personal information with their Extensions for Twitch.tv.</p>
            <h3>Does Polymedia use cookies?</h3>
            <p>Polymedia does not use cookies for any functionality of the Twitch Extensions.</p>
            <h3>What third party products or services does Polymedia use?</h3>
            <p>Polymedia uses Mollie to assist in the operation of the software, Mollie is used for its payment services. Mollie provides their own privacy policies, and Polymedia has no responsibility or liability for the content and activities of these services.</p>
            <h3>Does Polymedia disclose any information to outside parties?</h3>
            <p>No, none of your information is sold, traded or transfered to outside parties. This does not include aforementioned trusted third parties who assist in operation of the software, website, business or customer service. An exception could be made when it is appropriate to comply with the law, enforce the site policies, or to protect rights, property or safety.</p>
            <h3>Further information</h3>
            <h4>Terms and Conditions</h4>
            <p>The Terms and Conditions page establishes the use, disclaimers and limitations of liability regarding the use of the Polymedia website and software. These terms and conditions can be found at https://premium.polymedia.nl/terms.</p>
            <h4>Your consent</h4>
            <p>By using the Polymedia website and software, you consent to this Privacy Policy and the Terms and Conditions.</p>
            <h4>Changes to this Privacy Policy</h4>
            <p>This Privacy Policy is subject to change, any changes will be posted on this page and communicated through Twitter and possibly other channels.
            <br/><br/>This Privacy Policy was last modified on 13-04-2021.</p>

          </div>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Privacy.js